import { NgModule } from '@angular/core';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule} from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MenubarModule} from 'primeng/menubar';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { TreeTableModule } from 'primeng/treetable';
import { PasswordModule } from 'primeng/password';
import { SidebarModule } from 'primeng/sidebar';

import { ColgroupTableComponent } from './component/colgroup-table/colgroup-table.component';
import { DonutGraphComponent } from './component/donut-graph/donut-graph.component';
import { DownloadComponent } from './component/download/download.component';
import { DownloadTableComponent } from './component/download/table/download-table.component';
import { EntityComponent } from './component/entity/entity.component';
import { InwardTableComponent } from './component/inward/inward.component';
import { ReportTableComponent } from './component/report-table/report-table.component';
import { SimpleDialogComponent } from './component/simplecomponent/simplecomponent.component';
import { TableComponent } from './component/table/table.component';
import { InvoicemanagementDDComponent } from '../postlogin/invoicemanagement-dd/invoicemanagement-dd.component';
import { TaxIdcolGroupTableComponent } from './component/tax-idcol-group-table/tax-idcol-group-table.component';
import { FilterSidebarComponent } from '../postlogin/common/filter-sidebar/filter-sidebar.component';
import { FilterChipsComponent } from '../postlogin/common/filter-chips/filter-chips.component';

@NgModule({
  declarations: [
    ColgroupTableComponent,
    DonutGraphComponent,
    DownloadComponent,
    DownloadTableComponent,
    EntityComponent,
    InwardTableComponent,
    ReportTableComponent,
    SimpleDialogComponent,
    TableComponent,
    InvoicemanagementDDComponent,
    TaxIdcolGroupTableComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    CalendarModule,
    ChartModule,
    CheckboxModule,
    ConfirmDialogModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    DynamicDialogModule,
    FileUploadModule,
    InputSwitchModule,
    InputTextModule,
    MenubarModule,
    MenuModule,
    MultiSelectModule,
    RadioButtonModule,
    RatingModule,
    RippleModule,
    SelectButtonModule,
    SplitButtonModule,
    TableModule,
    TabMenuModule,
    TabViewModule,
    ToastModule,
    TooltipModule,
    TreeTableModule,
    PasswordModule,
    SidebarModule,
    FilterSidebarComponent,
    FilterChipsComponent
  ],
  exports:[
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CalendarModule,
    ChartModule,
    CheckboxModule,
    ConfirmDialogModule,
    DialogModule,
    DropdownModule,
    DynamicDialogModule,
    FileUploadModule,
    InputSwitchModule,
    InputTextModule,
    MenubarModule,
    MenuModule,
    MultiSelectModule,
    RadioButtonModule,
    RatingModule,
    SelectButtonModule,
    SplitButtonModule,
    TableModule,
    TabMenuModule,
    TabViewModule,
    TooltipModule,
    TreeTableModule,
    ColgroupTableComponent,
    DonutGraphComponent, 
    DownloadComponent,
    DownloadTableComponent,
    EntityComponent,
    InwardTableComponent,
    ReportTableComponent,
    SimpleDialogComponent,
    TableComponent,
    InvoicemanagementDDComponent,
    PasswordModule,
    SidebarModule,
    TaxIdcolGroupTableComponent,
    FilterSidebarComponent,
    FilterChipsComponent
  ],
  providers: [ConfirmationService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class SharedModule { }